/**
     * Example Usage:
     * Timeout.delayAction_Duration_>() => { 'Code' })
     */
export class Timeout {
    
    public static delayActionLong(action: () => any) {
        setTimeout(_ => {
            action();
        }, 3000);
    }

    public static delayActionShort(action: () => any) {
        setTimeout(_ => {
            action();
        }, 1500);
    }
}